import { AppBadge, AppBadgeForAno } from '@9b3kuq5phwuk4txw/kiban-react-ui'
import { ANO_INQUIRY_STATUSES, type AnoInquiryStatus } from 'shared'

type Props = {
  inquiryStatus: AnoInquiryStatus | null
  salesforceProjectId: number
  ano: string
  currentAnoProjectId?: number | null
}

/** currentAnoProjectIdを渡した場合、一致する ANO には引合ステータスバッジを表示しない */
export function BadgeForAnoStatus({ inquiryStatus, salesforceProjectId, ano, currentAnoProjectId }: Props) {
  const showInquiryBadge = currentAnoProjectId == null || salesforceProjectId !== currentAnoProjectId

  return (
    <span className='flex items-center gap-1'>
      {showInquiryBadge && inquiryStatus === ANO_INQUIRY_STATUSES.IN_PROGRESS && (
        <AppBadge color='amber' outline>
          引合進行中
        </AppBadge>
      )}
      {showInquiryBadge && inquiryStatus === ANO_INQUIRY_STATUSES.CONFIRMED && (
        <AppBadge color='green' outline>
          引合確定済
        </AppBadge>
      )}
      <AppBadgeForAno ano={ano} />
    </span>
  )
}
